<template>
  <div
    class="border-bottom pointer hover-highlight z2-conv-item-container"
    :class="app.selectedConversation.id === conversation.id && 'active-highlight'"
    @click="onSelectConversation">
    <div class="px-12 py-12 pb-1 d-flex align-items-start">
      <div class="z2-avatar-container mt">
        <img
          class="z2-avatar"
          :src="avatar" />
        <div
          v-if="!conversation.pushNotify"
          class="z2-badge">
          <img
            src="/assets/icon/Mute.png"
            style="min-width: 18px; max-width: 18px; min-height: 18px; max-height: 18px" />
        </div>
        <div
          v-if="conversation.unreadCount && conversation.pushNotify"
          class="z2-badge">
          {{ conversation.unreadCount }}
        </div>
      </div>
      <div class="d-flex flex-column flex-1 ps-2 ms-1 justify-content-between">
        <div
          class="d-flex align-items-center justify-content-between"
          style="position: relative">
          <el-tooltip
            effect="dark"
            :content="nameConversation"
            placement="top">
            <div class="d-flex align-items-center">
              <IconV2
                v-if="conversation.group"
                name="v2-group"
                color="red"
                size="x-sm"
                class="me-1" />
              <span
                class="font-14 fw-500 name-conversation trim-text-1-line"
                :style="{ 'max-width': conversation.isPin ? '130px' : '146px' }">
                {{ nameConversation }}
              </span>
            </div>
          </el-tooltip>
          <div class="d-flex justify-content-end align-items-center z2-conv-item-info">
            <span
              class="fw-300 font-12"
              :style="isConversationDraft && { color: ' #d91b1b' }">
              {{ !isConversationDraft ? lastMessageTime : "Chưa gửi" }}
            </span>
            <img
              v-if="conversation.isPin"
              class="ms-1"
              src="/assets/icon/favourite.png" />

            <el-tooltip
              class="item"
              effect="dark"
              :content="nameAccount"
              placement="top">
              <div>
                <img
                  class="z2-avatar-small ms-1"
                  :src="avatarAccount" />
              </div>
            </el-tooltip>
          </div>
          <div
            class="pointer z2-menu-context-btn"
            @click="showMenu">
            <IconV2
              name="el-icon-more"
              color="#3484F0" />
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="nameAccount"
            placement="top">
            <div class="pointer z2-avatar-tooltip">
              <img
                class="z2-avatar-small ms-1"
                :src="avatarAccount" />
            </div>
          </el-tooltip>
        </div>
        <span
          class="mt-1 font-14 trim-text-1-line max-width-222 mb-0"
          :class="conversationContent.type === 'unread' ? 'fw-500' : 'fw-400 text-grey600'"
          :style="(isConversationDraft || conversation.typing) && { color: '#005ae0 !important' }">
          {{ conversationContent.content }}
        </span>
      </div>
    </div>
    <el-tooltip
      effect="dark"
      placement="top"
      append-to-body
      :open-delay="150"
    >
      <template #content>
        <div class="tooltip-content">
          {{ summaryText }}
        </div>
      </template>
      <div
        v-if="hasScore"
        class="d-flex align-items-center mb-1"
        style="margin-left: 3.95rem"
      >
        <i
          v-for="i in 10"
          :key="i"
          class="fa-star"
          :class="i <= fullStars
            ? 'fa-solid text-warning'
            : 'fa-regular text-muted'"
        />
        <span class="ms-1 text-muted">({{ score }}/10)</span>
      </div>
    </el-tooltip>
    <ListTagEllipsis :tags="conversation.tags || []" />
  </div>
</template>

<script>
import dateUtil from "@/lib/date-util";
import ListTagEllipsis from "./ListTagEllipsis.vue";

export default {
  props: ["active", "accounts", "conversation"],
  components: {
    ListTagEllipsis,
  },
  data() {
    return {
      isMenuVisible: false,
    };
  },
  computed: {
    summaryText() {
      return (
        this.app.pointConversation?.[this.conversation.id]?.summaryContent
      );
    },
    score() {
      return this.app.pointConversation?.[this.conversation.id]?.satisfactionScore ?? null;
    },
    hasScore() {
      return this.score !== null && this.app.aiService !== 'none';
    },
    fullStars() {
      return Math.floor(this.score || 0);
    },
    hasHalfStar() {
      return this.score !== null && this.score % 1 >= 0.5;
    },
    scoreClass() {
      if (this.score >= 8) return 'score-high';
      if (this.score >= 5) return 'score-mid';
      return 'score-low';
    },
    avatar() {
      if (this.conversation.avatar) {
        return this.conversation.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },
    nameConversation() {
      return this.conversation.swName ? this.conversation.swName : this.conversation.toName;
    },
    lastMessageTime() {
      return dateUtil.timestampToDate(this.conversation.lastMessageTime * 1000000);
    },
    isConversationDraft() {
      return this.app.draftMessageList[this.conversation.id]?.content;
    },
    avatarAccount() {
      let filter = this.accounts.filter((a) => a.accountId == this.conversation.accountId);
      if (filter && filter.length > 0) {
        return filter[0].avatar;
      }
      return "";
    },
    nameAccount() {
      let filter = this.accounts.filter((a) => a.accountId == this.conversation.accountId);
      if (filter && filter.length > 0) {
        return this.getAccountName(filter[0]);
      }
      return "";
    },
    conversationContent() {
      if (this.conversation.typing) {
        return {
          type: "typing",
          content: this.conversation.lastMessageContent,
        };
      } else {
        if (this.isConversationDraft) {
          return {
            type: "draft",
            content: this.app.draftMessageList[this.conversation.id].content,
          };
        } else {
          const conversationContent =
            (this.conversation.group ? (this.conversation.dname ? this.conversation.dname + ": " : "Bạn: ") : "") +
            this.lastConversationType(this.conversation.lastContent, this.conversation.lastMessageContent, this.conversation.lastMessageType);
          const splitArray = conversationContent.split(":");
          const firstPart = splitArray[0].trim();
          const userLast = splitArray[0].trim();
          const content = conversationContent.substring(firstPart.length + 1).trim();
          return {
            type: this.conversation.unreadCount ? "unread" : "readed",
            content:
              (this.conversation.group ? (this.conversation.dname ? this.conversation.dname + ": " : "Bạn: ") : "") +
              this.lastConversationType(this.conversation.lastContent, this.conversation.lastMessageContent, this.conversation.lastMessageType),
            userLast: userLast,
            contentOnly: content,
          };
        }
      }
    },
  },
  methods: {
    onSelectConversation() {
      this.$emit("onSelect", this.conversation);
    },
    showMenu(e) {
      this.$emit("showMenu", e);
      e.preventDefault();
      e.stopPropagation();
    },
  },
};
</script>

<style scoped>
.score-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* màu theo score */
.score-high {
  background-color: #22c55e; /* xanh lá */
}

.score-mid {
  background-color: #f59e0b; /* cam */
}

.score-low {
  background-color: #ef4444; /* đỏ */
}
.score-high {
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34,197,94,.6); }
  70% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
  100% { box-shadow: 0 0 0 0; }
}
</style>